export default __webpack_public_path__ + "static/media/CastActive.3e3deba7.svg";